export default __webpack_public_path__ + "4de99a8f223a83d8a116c3f8ed696115.mp3";